import { render, staticRenderFns } from "./ExternalButton.vue?vue&type=template&id=7e5089ec&"
import script from "./ExternalButton.vue?vue&type=script&lang=js&"
export * from "./ExternalButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports